<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Order Listing
        </h4>
        <div class="order-filter-bar">
          <!-- Search -->
          <div class="search-box">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control" placeholder="Search orders..." [(ngModel)]="searchQuery"
              (input)="onSearchChange()" />
          </div>

          <!-- User Filter -->
          <div class="user-filter-box position-relative" #userFilterContainer>
            <input type="text" class="form-control" placeholder="Search user..." [(ngModel)]="userSearchQuery"
              (input)="onUserSearchChange()" (focus)="isUserDropdownOpen = true" (click)="isUserDropdownOpen = true" />
            <!-- <button
              class="btn-clear"
              *ngIf="selectedUserId"
              (click)="clearUserFilter(); $event.stopPropagation()"
            >
              <i class="fa fa-times-circle"></i>
            </button> -->
            <!-- <i class="fa fa-chevron-down" *ngIf="!selectedUserId"></i> -->

            <div class="user-dropdown shadow" *ngIf="isUserDropdownOpen">
              <div class="p-3 text-center" *ngIf="loadingUsers">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span class="ms-2 small"> Searching...</span>
              </div>
              <ng-container *ngIf="!loadingUsers">
                <div class="user-item" (click)="clearUserFilter()" [class.active]="!selectedUserId">
                  <div class="user-name">All Users</div>
                </div>
                <div class="user-item" *ngFor="let user of users" (click)="selectUser(user)"
                  [class.active]="user._id === selectedUserId">
                  <div class="user-name">{{ getUserDisplayName(user) }}</div>
                </div>
                <div class="p-3 text-center small text-muted" *ngIf="users.length === 0 && userSearchQuery">
                  No users found
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Status Filter -->
          <div class="status-box">
            <i class="fa fa-filter"></i>
            <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
              <option value="all">All Status</option>
              <option *ngFor="let status of statusList.slice(1)" [value]="status">
                {{ status | titlecase }}
              </option>
            </select>
          </div>
          <!-- Export CSV -->
          <button class="btn btn-primary export-csv-btn" (click)="exportCsv()" [disabled]="exportingCsv">
            <i class="fa" [ngClass]="exportingCsv ? 'fa-spinner fa-spin' : 'fa-download'"></i>
            {{ exportingCsv ? 'Exporting...' : 'Export CSV' }}
          </button>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Actions</th>
              <th scope="col">Order Number</th>
              <th scope="col">Status</th>
              <th scope="col">Total Amount</th>
              <th scope="col">Delivery Type</th>
              <th scope="col">Pickup Address</th>
              <th scope="col">User Name</th>
              <th scope="col">User Email</th>
              <th scope="col">User Address</th>
              <th scope="col">User Mobile</th>
              <th scope="col">Payment Method</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders">
              <td>
                <div class="d-flex flex-row">
                  <!-- View Details Icon Button -->
                  <button class="btn btn-sm btn-primary m-1" (click)="viewOrderDetails(order)" placement="top"
                    ngbTooltip="View details">
                    <i class="fa fa-eye"></i>
                  </button>

                  <ng-container *ngIf="order.deliveryType === 'pickup'">
                    <button *ngIf="getAvailableActions(order).includes('readyForPickUp')"
                      class="btn btn-primary btn-sm m-1" (click)="confirmAction(order, 'ready for pickup')"
                      placement="top" ngbTooltip="Ready for Pickup">
                      <i class="fa fa-hand-o-up"></i>
                    </button>

                    <button *ngIf="getAvailableActions(order).includes('complete')" class="btn btn-success btn-sm m-1"
                      (click)="confirmAction(order, 'complete')" placement="top" ngbTooltip="Complete Order">
                      <i class="fa fa-check"></i>
                    </button>

                    <button *ngIf="getAvailableActions(order).includes('cancel')" class="btn btn-danger btn-sm m-1"
                      (click)="confirmAction(order, 'cancel', true)" placement="top" ngbTooltip="Cancel Order">
                      <i class="fa fa-times"></i>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="order.deliveryType === 'delivery'">
                    <button *ngIf="getAvailableActions(order).includes('accept')" class="btn btn-success btn-sm m-1"
                      (click)="confirmAction(order, 'accept')" placement="top" ngbTooltip="Accept Order">
                      <i class="fa fa-check"></i>
                    </button>

                    <!-- Out for Delivery Icon -->
                    <button *ngIf="
                        getAvailableActions(order).includes('outForDelivery')
                      " class="btn btn-info btn-sm m-1" (click)="confirmAction(order, 'out for delivery')"
                      placement="top" ngbTooltip="Mark as Out for Delivery">
                      <i class="fa fa-truck"></i>
                    </button>

                    <!-- Complete Icon -->
                    <button *ngIf="getAvailableActions(order).includes('complete')" class="btn btn-primary btn-sm m-1"
                      (click)="confirmAction(order, 'complete')" placement="top" ngbTooltip="Complete Order">
                      <i class="fa fa-check-circle"></i>
                    </button>

                    <!-- Cancel Icon -->
                    <button *ngIf="getAvailableActions(order).includes('cancel')" class="btn btn-danger btn-sm m-1"
                      (click)="confirmAction(order, 'cancel', true)" placement="top" ngbTooltip="Cancel Order">
                      <i class="fa fa-times"></i>
                    </button>
                  </ng-container>
                </div>
              </td>
              <td>{{ order.orderNumber }}</td>
              <td>
                <span class="badge" style="
                    border-radius: 20px;
                    padding-left: 10px;
                    padding-right: 10px;
                    font-size: 13px;
                  " [ngClass]="getStatusBadgeClass(order.status)">
                  {{ order.status | titlecase }}
                </span>
              </td>

              <td class="text-danger font-bold">
                {{ order.currency }}
                {{ order.chargeableAmount / 100 | number: "1.2-2" }}
              </td>
              <td>
                {{
                order.storeDeliveryServiceId
                ? "Shipping"
                : order.deliveryType === "delivery"
                ? "Home Delivery"
                : (order.deliveryType | titlecase)
                }}
              </td>
              <td>
                <p placement="top" [ngbTooltip]="
                    order.deliveryType === 'pickup'
                      ? order.storeLocationId?.address ||
                        order.operatorStoreId?.storeAddress
                      : null
                  ">
                  {{
                  order.deliveryType === "pickup"
                  ? (
                  order.storeLocationId?.address ||
                  order.operatorStoreId?.storeAddress
                  )?.length > 30
                  ? (order.storeLocationId?.address ||
                  order.operatorStoreId?.storeAddress
                  | slice: 0 : 20) + "..."
                  : order.storeLocationId?.address ||
                  order.operatorStoreId?.storeAddress
                  : "-"
                  }}
                </p>
              </td>
              <td>{{ order.user_id.name }}</td>
              <td>{{ order.user_id.email }}</td>
              <td>
                <p placement="top" [ngbTooltip]="order.userAddress">
                  {{
                  order?.userAddress?.length > 30
                  ? (order.userAddress | slice: 0 : 20) + "..."
                  : order.userAddress
                  }}
                </p>
              </td>
              <td>
                {{ order.user_id.dialling_code || "" }}
                {{ order.user_id.mobile }}
              </td>
              <td>{{ order.paymentMethodType }}</td>
              <td>{{ order.created_at | date: "medium" }}</td>
            </tr>
            <tr *ngIf="orders?.length == 0 && !loading">
              <td colspan="11" class="text-center">No orders found</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="d-flex justify-content-center mt-5" *ngIf="orders?.length != 0">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>